export default {
  SELF: "self",
  MIXED: "mixed",
};
